import { render, staticRenderFns } from "./MultilanguageList.vue?vue&type=template&id=6d3e8266&scoped=true"
import script from "./MultilanguageList.vue?vue&type=script&lang=js"
export * from "./MultilanguageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3e8266",
  null
  
)

export default component.exports